import { render, staticRenderFns } from "./custom-case.vue?vue&type=template&id=3fd55262&scoped=true&"
import script from "./custom-case.vue?vue&type=script&lang=js&"
export * from "./custom-case.vue?vue&type=script&lang=js&"
import style0 from "./custom-case.vue?vue&type=style&index=0&id=3fd55262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd55262",
  null
  
)

export default component.exports